import axios from 'axios';

const TMDB_KEYS = [
  'c8dea14dc917687ac631a52620e4f7ad',
  '3cb41ecea3bf606c56552db3d17adefd',
];
let keyIndex = 0;
const getKey = () => TMDB_KEYS[keyIndex % TMDB_KEYS.length];

const BASE = 'https://api.themoviedb.org/3';
export const IMG_BASE = 'https://image.tmdb.org/t/p';
export const imgUrl = (path, size = 'w500') =>
  path ? `${IMG_BASE}/${size}${path}` : null;

const tmdb = axios.create({ baseURL: BASE, timeout: 15000 });

tmdb.interceptors.request.use((config) => {
  config.params = { api_key: getKey(), language: 'en-US', ...(config.params || {}) };
  return config;
});

tmdb.interceptors.response.use(
  (r) => r,
  async (err) => {
    const status = err?.response?.status;
    if ((status === 401 || status === 429) && keyIndex < TMDB_KEYS.length * 2) {
      keyIndex += 1;
      const cfg = err.config;
      cfg.params = { ...cfg.params, api_key: getKey() };
      return tmdb.request(cfg);
    }
    return Promise.reject(err);
  }
);

export const endpoints = {
  trending: (type = 'all', window = 'week') => `/trending/${type}/${window}`,
  popularMovies: '/movie/popular',
  topMovies: '/movie/top_rated',
  nowPlaying: '/movie/now_playing',
  upcoming: '/movie/upcoming',
  popularTV: '/tv/popular',
  topTV: '/tv/top_rated',
  onAirTV: '/tv/on_the_air',
  genreMovies: '/discover/movie',
  genreTV: '/discover/tv',
  movieDetail: (id) => `/movie/${id}`,
  tvDetail: (id) => `/tv/${id}`,
  movieVideos: (id) => `/movie/${id}/videos`,
  tvVideos: (id) => `/tv/${id}/videos`,
  search: '/search/multi',
  genres: (type) => `/genre/${type}/list`,
};

export const getList = async (path, params = {}) => {
  const { data } = await tmdb.get(path, { params });
  return (data.results || []).filter((x) => x.poster_path || x.backdrop_path);
};

export const getDetail = async (mediaType, id) => {
  const path = mediaType === 'tv' ? endpoints.tvDetail(id) : endpoints.movieDetail(id);
  const { data } = await tmdb.get(path, { params: { append_to_response: 'videos,credits,similar' } });
  return data;
};

export const getTrailerKey = async (mediaType, id) => {
  try {
    const path = mediaType === 'tv' ? endpoints.tvVideos(id) : endpoints.movieVideos(id);
    const { data } = await tmdb.get(path);
    const results = data.results || [];
    const yt = results.filter((v) => v.site === 'YouTube');
    const trailer =
      yt.find((v) => v.type === 'Trailer' && v.official) ||
      yt.find((v) => v.type === 'Trailer') ||
      yt.find((v) => v.type === 'Teaser') ||
      yt[0];
    return trailer?.key || null;
  } catch {
    return null;
  }
};

export const search = async (q) => {
  if (!q) return [];
  const { data } = await tmdb.get(endpoints.search, { params: { query: q, include_adult: false } });
  return (data.results || []).filter(
    (r) => (r.media_type === 'movie' || r.media_type === 'tv') && (r.poster_path || r.backdrop_path)
  );
};

export const getWatchProviders = async (mediaType, id, region = 'US') => {
  try {
    const path = mediaType === 'tv' ? `/tv/${id}/watch/providers` : `/movie/${id}/watch/providers`;
    const { data } = await tmdb.get(path);
    const r = (data.results || {})[region] || (data.results || {}).US || {};
    return {
      link: r.link || null,
      flatrate: r.flatrate || [],
      rent: r.rent || [],
      buy: r.buy || [],
      free: r.free || [],
      ads: r.ads || [],
    };
  } catch {
    return { link: null, flatrate: [], rent: [], buy: [], free: [], ads: [] };
  }
};

export default tmdb;
